import { render, staticRenderFns } from "./editBase.vue?vue&type=template&id=3264168e&scoped=true"
import script from "./editBase.vue?vue&type=script&lang=js"
export * from "./editBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3264168e",
  null
  
)

export default component.exports